export default {
	firestorePath: "content",
	firestoreRefType: "collection",
	moduleName: "content",
	statePropName: "data",
	namespaced: true,
	state: {},
	getters: {
	},
	sync: {
		defaultValues: {
			status: "published"
		}
	},
	mutations: {},
	actions: {
	},
};
